import { ViewStyle } from 'react-native';
import useStyle from '../../../hooks/useStyle';

export const useToastStyles = () => {
  const baseStyle = useStyle<ViewStyle>({
    borderLeftWidth: 'border-width-0',
    borderLeftColor: 'transparent',
    gap: 'space-200',
    padding: 'space-300',
    borderRadius: 'radius-200',
    alignItems: 'center',
  });

  const successStyle = useStyle<ViewStyle>({
    backgroundColor: 'primarySolidBackgroundPale',
  });

  const containerStyle = useStyle<ViewStyle>({
    paddingHorizontal: 'space-0',
  });

  const textStyle = useStyle<ViewStyle>({
    fontSize: 'text-100',
    color: 'accentSurfacePrimary',
  });

  const errorTextStyle = useStyle<ViewStyle>({
    fontSize: 'text-100',
    color: 'darkSurfacePrimary',
  });

  const errorStyle = useStyle<ViewStyle>({
    backgroundColor: 'tertiaryBackground',
  });

  return {
    baseStyle,
    successStyle,
    containerStyle,
    textStyle,
    errorTextStyle,
    errorStyle,
  };
};
